// Bestätigung für data-turbo-confirm als modales <dialog>. Turbo ruft die
// Funktion mit dem Text auf und wartet auf das Promise (true = absenden).
// Die Beschriftungen kommen aus <meta name="ui-confirm-ok|ui-confirm-cancel">.
function label(name, fallback) {
  return document.querySelector(`meta[name="${name}"]`)?.content || fallback
}

export function confirmDialog(message) {
  return new Promise((resolve) => {
    const dialog = document.createElement("dialog")
    dialog.className = "confirm-dialog"
    dialog.setAttribute("aria-labelledby", "confirm-dialog-message")

    const text = document.createElement("p")
    text.id = "confirm-dialog-message"
    text.textContent = message

    const form = document.createElement("form")
    form.method = "dialog"
    form.className = "confirm-dialog__actions"

    const cancel = document.createElement("button")
    cancel.type = "submit"
    cancel.value = "cancel"
    cancel.className = "btn"
    cancel.textContent = label("ui-confirm-cancel", "Abbrechen")

    const ok = document.createElement("button")
    ok.type = "submit"
    ok.value = "ok"
    ok.className = "btn btn--primary"
    ok.textContent = label("ui-confirm-ok", "Bestätigen")

    form.append(cancel, ok)
    dialog.append(text, form)

    // Esc schließt ohne returnValue → false
    dialog.addEventListener(
      "close",
      () => {
        resolve(dialog.returnValue === "ok")
        dialog.remove()
      },
      { once: true },
    )

    document.body.append(dialog)
    dialog.showModal()
    // Fokus auf die harmlose Wahl
    cancel.focus()
  })
}
